"use client";

import { getCookie } from "cookies-next/client";
import { useSearchParams } from "next/navigation";

import type { FormContext } from "@/schemas";

export const useHubspotContext = (): FormContext => {
  const hubspotutk = getCookie("hubspotutk");
  const referralId = getCookie("wf_referral_id");
  const psClickId = getCookie("wf_click_ext_id");
  const psPartnerKey = getCookie("wf_ps_partner_key");
  const searchParams = useSearchParams();

  let utmSource = "";
  let utmMedium = "";
  let utmCampaign = "";

  if (searchParams) {
    utmSource = searchParams.get("utm_source") ?? "";
    utmMedium = searchParams.get("utm_medium") ?? "";
    utmCampaign = searchParams.get("utm_campaign") ?? "";
  }

  // Read directly on render rather than via useEffect: event handlers (the
  // submit button) attach synchronously during hydration, before an effect
  // would run, so a fast submit could otherwise send an empty pageURI/pageName.
  const pageURI = typeof window !== "undefined" ? window.location.href : "";
  const pageName = typeof document !== "undefined" ? document.title : "";

  return {
    hubspotutk: hubspotutk ? hubspotutk : null,
    pageURI,
    pageName,
    additionalProperties: {
      psClickId: psClickId ? psClickId : null,
      psPartnerKey: psPartnerKey ? psPartnerKey : null,
      referralId: referralId ? referralId : null,
      utmSource,
      utmMedium,
      utmCampaign,
    },
  };
};
